import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { DICT } from "../lib/i18n";
import { useContent } from "./ContentContext";

const LangCtx = createContext(null);
export const useLang = () => useContext(LangCtx);

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("lo_lang") || "fr");
  const content = useContent();

  useEffect(() => {
    localStorage.setItem("lo_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const setLang = (l) => setLangState(l === "en" ? "en" : "fr");

  const t = useCallback(
    (key) => {
      // 1) Surcharge admin (CMS) prioritaire si non vide
      const o = content?.texts?.[key];
      if (o && typeof o === "object") {
        const s = o[lang] ?? o.fr;
        if (typeof s === "string" && s.trim()) return s;
      }
      // 2) Dictionnaire par défaut FR/EN
      const table = DICT[lang] || DICT.fr;
      return table[key] ?? DICT.fr[key] ?? key;
    },
    [lang, content]
  );

  return <LangCtx.Provider value={{ lang, setLang, t }}>{children}</LangCtx.Provider>;
}
